import React from 'react';
import { FaUsers, FaCheck } from 'react-icons/fa';
import Modal from '../../../components/Utils/ModalShow';
import EmployeeListModal from './EmployeeListModal';

const PayslipConfirmModal = ({
    isOpen,
    onClose,
    title,
    subtitle,
    headerIcon,
    employeesToShow,
    modalSelectedEmployees,
    setModalSelectedEmployees,
    selectedCount,
    totalCount,
    handleConfirm,
}) => (
    <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        subtitle={subtitle}
        headerIcon={headerIcon}
        size={800}
        footer={
            <>
                <button
                    className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 font-medium"
                    onClick={onClose}
                >
                    Annuler
                </button>
                <button
                    className="px-6 py-2 bg-[--color-primary] hover:bg-[--bg-hover] text-white rounded-lg transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                    onClick={handleConfirm}
                    disabled={selectedCount === 0}
                >
                    <FaCheck size={14} />
                    Confirmer ({selectedCount})
                </button>
            </>
        }
    >
        <div className="p-6 border-b border-gray-200 flex-shrink-0">
            <div className="flex items-center justify-between">
                <div className="text-sm text-gray-700">
                    <span className="font-medium">{selectedCount}</span> employé(s) sélectionné(s) sur <span className="font-medium">{totalCount}</span>
                </div>
                <div className="flex gap-2">
                    <button
                        className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
                        onClick={() => setModalSelectedEmployees(employeesToShow)}
                        type="button"
                    >
                        Tout sélectionner
                    </button>
                    <button
                        className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
                        onClick={() => setModalSelectedEmployees([])}
                        type="button"
                    >
                        Tout désélectionner
                    </button>
                </div>
            </div>
        </div>
        <EmployeeListModal
            employees={employeesToShow}
            selectedEmployees={modalSelectedEmployees}
            setSelectedEmployees={setModalSelectedEmployees}
        />
    </Modal>
);

export default PayslipConfirmModal;